import React, { useEffect, useState } from 'react'
import SectionQuestion from './SectionQuestion';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useDispatch } from 'react-redux';
import { orderQuestion } from '../../../../../../../store/actions/qnaBuilderAction';


const SectionContent = ({ questions, language_code, survey_id }) => {
  //States
  const [sortableQuestions, setSortableQuestions] = useState([])
  const dispatch = useDispatch()

  //React-beautiful-dnd
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  }

  const onDragEnd = (result) => {
    if (window.modulePermissions.M11.edit != 1) {
      return;
    }

    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const tmpQuestions = reorder(
      sortableQuestions,
      result.source.index,
      result.destination.index
    )
    const afterSort = () => {
      console.log('Question sorted...')
    }
    const payload = { question_order: fetchPayloadForUpdateOrderingApi(tmpQuestions) }
    setSortableQuestions(tmpQuestions)
    dispatch(orderQuestion(payload, afterSort))
  }

  //Generate payload
  const fetchPayloadForUpdateOrderingApi = (ques) => {
    const payload = {}
    ques?.forEach((que, index) => {
      payload[que.su_question_id] = index + 1
    })
    return payload
  }

  //Effcts
  useEffect(() => {
    if (questions) {
      setSortableQuestions([...questions])
    }
  }, [questions])

  return (
    <div className="content-wrapper-trans">

      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="questionList">
          {provided => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {
                questions?.map((question, index) => {
                  return (
                    <React.Fragment key={index}>
                      <Draggable draggableId={`questionList${index}`} index={index}>
                        {provided => (
                          <SectionQuestion
                            question={question}
                            language_code={language_code}
                            survey_id={survey_id}
                            questionId={question?.su_question_id}
                            questionIndex={index + 1}
                            provided={provided}
                          />
                        )}
                      </Draggable>
                    </React.Fragment>
                  )
                })
              }
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div >
  )
}

export default SectionContent